export interface RawSubscriptionApiResponse {
  id: string;
  delivery_method: SubscriptionDeliveryMethod;
  event_types: SubscriptionEventType[];
  created_at: string;
  updated_at: string;
  status: SubscriptionStatus;
}

export interface Email {
  email: string;
}

export type SubscriptionDeliveryMethod = Email;

export enum SubscriptionEventType {
  ADVERTISER_CREATED_SIGNED_UP = 'advertiser:created:signed-up',
  LINE_ITEM_UPDATED_NEEDS_APPROVAL = 'line-item:updated:needs-approval',
  LINE_ITEM_UPDATED_RETAILER_STATUS_CHANGED = 'line-item:updated:retailer-status-changed',
  LINE_ITEM_BUDGET_THRESHOLD_REACHED_90_PERCENT = 'line-item:budget-threshold-reached:90-percent',
  CAMPAIGN_BUDGET_THRESHOLD_REACHED_90_PERCENT = 'campaign:budget-threshold-reached:90-percent',
  LINE_ITEM_NO_IMPRESSIONS_DAILY = 'line-item:no-impressions:daily',
  CAMPAIGN_NO_IMPRESSIONS_DAILY = 'campaign:no-impressions:daily',
  LINE_ITEM_BUDGET_DEPLETED_DAILY = 'line-item:budget-depleted:daily',
  CAMPAIGN_BUDGET_DEPLETED_DAILY = 'campaign:budget-depleted:daily',
  LINE_ITEM_DRAFT_STALE = 'line-item:draft:stale',
  CAMPAIGN_DRAFT_STALE = 'campaign:draft:stale',
}

export enum SubscriptionStatus {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED',
}
